import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';

export interface LinkProps {
  children: React.ReactNode;
  href: string;
}

/**
 * A custom link that parses Markdown for on-site vs off-site URLs
 * and formats as a Gatsby link or standard anchor tag.
 */
export const Link = ({ children, href }: LinkProps) => {
  if (href.startsWith('/')) {
    // Remove automatically injected path prefix by gatsby-plugin-mdx to leverage internal Gatsby link
    const to =
      process.env.NODE_ENV === 'production' && href.includes('/docs/')
        ? `/${href.split('/').slice(2).join('/')}/`
        : href;
    return <GatsbyLink to={to}>{children}</GatsbyLink>;
  }

  const onPage = href.startsWith('#');
  const attributes = !onPage
    ? {
        target: '_blank',
        rel: 'noreferrer',
      }
    : null;

  return (
    <a href={href} {...attributes}>
      {children}
    </a>
  );
};
